import React, { useState, useEffect, useRef } from 'react';
import { motion } from 'framer-motion';

const PROMPT = 'sreedeep@portfolio:~$';

function typingDelay(char, prevChar) {
  const base = 75 + Math.random() * 55;
  if (char === ' ') return base + 35 + Math.random() * 50;
  if ('.·-:/[]'.includes(char)) return base + 50 + Math.random() * 70;
  if (prevChar === ' ') return base + 25;
  return base;
}

const STEPS = [
  { type: 'prompt' },
  { type: 'type',   text: 'whoami' },
  { type: 'enter' },
  { type: 'output', text: 'Sreedeep CV', delay: 100, kind: 'name' },
  { type: 'gap',    delay: 320 },
  { type: 'prompt' },
  { type: 'type',   text: 'cat role.txt' },
  { type: 'enter' },
  { type: 'output', text: 'Security Researcher · CTF Developer', delay: 90, kind: 'role' },
  { type: 'gap',    delay: 350 },
  { type: 'prompt' },
  { type: 'type',   text: 'cat focus.txt' },
  { type: 'enter' },
  { type: 'output', text: 'VAPT  ·  Malware Analysis  ·  CTF Author  ·  AI Security', delay: 90, kind: 'focus' },
  { type: 'gap',    delay: 350 },
  { type: 'prompt' },
  { type: 'type',   text: 'echo $LOCATION' },
  { type: 'enter' },
  { type: 'output', text: 'Bangalore, India', delay: 80, kind: 'loc' },
  { type: 'gap',    delay: 400 },
  { type: 'done' },
];

export default function Hero() {
  const [lines, setLines] = useState([]);
  const [currentLine, setCurrentLine] = useState('');
  const [cursorVisible, setCursorVisible] = useState(true);
  const [done, setDone] = useState(false);
  const stepRef = useRef(0);
  const charRef = useRef(0);

  useEffect(() => {
    const id = setInterval(() => setCursorVisible(v => !v), 530);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    let timeout;

    function advance() {
      const step = STEPS[stepRef.current];
      if (!step) return;

      if (step.type === 'prompt') {
        setCurrentLine(PROMPT + ' ');
        stepRef.current++;
        charRef.current = 0;
        timeout = setTimeout(advance, 160 + Math.random() * 110);

      } else if (step.type === 'type') {
        const idx = charRef.current;
        if (idx < step.text.length) {
          const ch = step.text[idx];
          const prev = idx > 0 ? step.text[idx - 1] : '';
          setCurrentLine(prev => prev + ch);
          charRef.current++;
          timeout = setTimeout(advance, typingDelay(ch, prev));
        } else {
          stepRef.current++;
          charRef.current = 0;
          timeout = setTimeout(advance, 180 + Math.random() * 90);
        }

      } else if (step.type === 'enter') {
        setLines(prev => [...prev, { kind: 'cmd', text: currentLine }]);
        setCurrentLine('');
        stepRef.current++;
        timeout = setTimeout(advance, step.delay || 180);

      } else if (step.type === 'output') {
        setLines(prev => [...prev, { kind: step.kind || 'output', text: step.text }]);
        stepRef.current++;
        timeout = setTimeout(advance, step.delay || 140);

      } else if (step.type === 'gap') {
        stepRef.current++;
        timeout = setTimeout(advance, step.delay || 300);

      } else if (step.type === 'done') {
        setDone(true);
      }
    }

    timeout = setTimeout(advance, 500);
    return () => clearTimeout(timeout);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const currentLineRef = useRef('');
  useEffect(() => { currentLineRef.current = currentLine; }, [currentLine]);

  return (
    <motion.section
      id="hero"
      className="section hero"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="hero-terminal">
        <div className="hero-terminal-bar">
          <span className="hero-dot" style={{ background: '#ff5f56' }} />
          <span className="hero-dot" style={{ background: '#ffbd2e' }} />
          <span className="hero-dot" style={{ background: '#27c93f' }} />
          <span className="hero-bar-title">sreedeep — bash — 80×24</span>
        </div>

        <div className="hero-terminal-body">
          {lines.map((l, i) =>
            l.kind === 'cmd' ? (
              <div key={i} className="hero-line hero-line-cmd">
                <span className="hero-prompt-text">{l.text}</span>
              </div>
            ) : (
              <div key={i} className={`hero-line hero-out-${l.kind}`}>
                {l.text}
              </div>
            )
          )}

          {!done && (
            <div className="hero-line hero-line-cmd">
              <span className="hero-prompt-text">{currentLine}</span>
              <span className={`hero-block-cursor ${cursorVisible ? 'visible' : ''}`}>▌</span>
            </div>
          )}

          {done && (
            <div className="hero-line hero-line-cmd">
              <span className="hero-prompt-text">{PROMPT}&nbsp;</span>
              <span className={`hero-block-cursor ${cursorVisible ? 'visible' : ''}`}>▌</span>
            </div>
          )}
        </div>
      </div>
    </motion.section>
  );
}
